<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-draw-delivery"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-head">
                    <div id="draw_campaign_img">
                        <img :src="campaign.fullImageUrl" />
                    </div>
                </div>
                <div class="modal-base-body">
                    <p id="draw_delivery_title" v-html="lbl.draw_delivery.title"></p>
                    <p id="draw_delivery_msg" v-html="lbl.draw_delivery.msg"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="announce_btn"
                        :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                        <div class="btn-txt"
                            @click="clickClose()">{{lbl.default.close}}</div>
                    </div>

                    <div id="seperate_line"></div>
                    <div id="serial_bzbslogo">
                        <img src="@/assets/bzbslogo/buzzebees-logo-dark@3x.png"/>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: 'DrawDeliveryModal',
    mixins: [LocaleMixin],
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            campaign: {},
            tag: null,

            busModal: null
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickAnnouncement: function () {
            this.controller.cbAction.sendCallback({tag: this.tag, action: 'history'});
            this.$nextTick(() => {
                this.hide();
            });
        },
        clickClose: function () {
            this.hide();
        },
        //initial
        show: function (config) {
            this.campaign = config.campaign;
            this.tag = config.tag;

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

p {
    margin-bottom: 0;
}

#draw_campaign_img {
    width: 60%;
    border-radius: 10px;
    margin: auto;
    @include baseRatioImg(66.67%);
}

#draw_delivery_title {
    font-size: 1.5rem;
    // font-family: $heading;
    // line-height: 1;
    text-align: center;
    margin-bottom: 5px;
}

#draw_delivery_msg {
    font-size: 1.3rem;
    // font-family: $body;
    // line-height: 1;
    text-align: center;
}

#announce_btn {
    $width: 80%;
    $fade_mass: url(../../../../assets/share/tab/mass/mass-fade-menu@3x.png);
    $fase_prestige: url(../../../../assets/share/tab/prestige/prestige-fade-menu@3x.png);
    @include btn-wrapper($width, $fade_mass, $fase_prestige);
    margin-bottom: 25px;

    %base-btn-txt {
        font-size: 1.5rem;
        // font-family: $heading;
    }

    &.mass {
        .btn-txt {
            @extend %base-btn-txt;
        }
    }

    &.prestige {
        .btn-txt {
            @extend %base-btn-txt;
        }
    }
}

#seperate_line {
    border-top: 1px solid #707070;
    opacity: 0.2;
}

#serial_bzbslogo {
    padding: {
        top: 15px;
        bottom: 15px;
    };

    img {
        display: block;
        height: 20px;
        margin: {
            left: auto;
            right: auto;
        };
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

.modal-draw-delivery {
    @extend %modal-base;

    .modal-dialog {
        margin: 19px;
    }

    .modal-body {
        padding: 0;

        // .modal-base-close {
        //     position: absolute;
        //     top: 0;
        //     right: 0;
        //     width: 34px;
        //     height: 34px;
        //     z-index: 100;
        //     background-image: url(../../../../assets/icon/prestige/ic-close.svg);
        //     background-position: center center;
        //     background-size: 100% 100%;
        // }
    }

    .modal-base {
        padding: {
            left: 30px;
            right: 30px;
        };
        border-radius: 10px;

        &.mass {
            background-color: #ffffff;

            #draw_delivery_title {
                color: $mass_modal_message;
            }

            #draw_delivery_msg {
                color: $mass_modal_message;
            }
        }

        &.prestige {
            background-color: #fffdf8;

            #draw_delivery_title {
                color: $prestige_modal_headline;
            }

            #draw_delivery_msg {
                color: $prestige_modal_message;
            }
        }

        .modal-base-head {
            padding: {
                top: 45px;
                bottom: 0;
            };
        }

        .modal-base-body {
            padding: {
                top: 30px;
                bottom: 45px;
            };
        }
    }
}
</style>
